import { Link } from '@remix-run/react';

import Icon from '../Icon';

const InternationalHeader = () => {
  return (
    <header className="main-header sticky top-0" role="banner">
      <div className="main-header__content">
        <section className="main-header__container">
          <Link to="/" className="main-header__logo-link">
            <Icon
              name="sole-icon"
              width="50"
              height="50"
              viewBox="0 0 58 44"
              fill="#FFFFFF"
              className="main-header__logo"
            />
          </Link>
        </section>
      </div>
    </header>
  );
};

export default InternationalHeader;
